import { TranslateField } from "../../types/translate-field"

export interface GetPortalResponse {
    items: PortalLinkDB[]
}

export interface PortalLinkDB {
    id: number
    system_name: string
    link?: string
}

export interface PortalLink {
    name: string
    link: string
    location: 'admin' | 'hk' | 'cn' | 'ext'
}

const hkDomain = 'hkconnections'
const cnDomain = 'cnconnections'

export const ToPortalLink = (data: PortalLinkDB): PortalLink => {
    return {
        name: data.system_name,
        link: data.link ?? '',
        location: !data.link ? 'admin' : data.link.includes(hkDomain) ? 'hk' : data.link.includes(cnDomain) ? 'cn' : 'ext'
    }
}